module.exports = {
  frontendURL: "https://apps2.library.cmu.ac.th/renew/",
  backendURL: "https://cloud-3003.lib.cmu.ac.th/",
  itaccount: "https://cloud.library.cmu.ac.th/cloudplatform/itaccount",

  // frontendURL: "http://localhost:3000/renew/",
  // backendURL: "http://localhost:3003/",
  signinURL: "https://apis-3003.lib.cmu.ac.th/platform/oauth/",
  cookieName: "cmul-renew",
};
